import { Component, ViewEncapsulation } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { ToastService } from '../../services/toast.service';

@Component({
    selector: 'ez-toast',
    template: require('./toast.component.html'),
    styles: [require('./toast.component.less')],
    encapsulation: ViewEncapsulation.None,
    animations: [
        trigger('visibilityChanged', [
            state('1', style({ visibility: 'visible' })),
            state('0', style({ visibility: 'hidden' })),
            transition('1 => 0',
                animate(
                    '500ms',
                    style({ opacity: 0})
                )
            )
        ])
    ]
})
export class ToastComponent {

    constructor(
        private toastService: ToastService
    ) {}

    public animationDone($event) {
        if ($event.toState === false) {
            this.toastService.reset();
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./src/app/components/toast/toast.component.ts